import { buildContext } from '@toss/react';
import { type SupportedCountryCode } from '@zep-us/i18n';

import type { CategoryTreeBuildDto } from '@/api/gen/_model/categoryTreeBuildDto';
import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { type CategoryTree } from '@/shared/category/type';
import { type MapTemplate } from '@/types';

import { type SelectionSchoolInfo } from '../type';

export type BuildAction = 'CREATE' | 'UPDATE' | 'DUPLICATE';
export type BuildType = Lowercase<BuildAction>;

/** 현재 빌드 페이지의 생성에 필요한 정보를 관리하는 컨텍스트 */
export const [BuildInfoProvider, useBuildInfoContext] =
  buildContext<BuildInfoProviderType>('BuildContext', null);

export type BuildInfoProviderType = {
  action: BuildAction;
  mapTemplates: MapTemplate[];
  /** 복사/ 업데이트 시 사용되는 데이터 */
  originQuizSet: QuizSetDetailsRes | undefined;
  schoolInfoTree: CategoryTree;
  subjectTree: CategoryTreeBuildDto[];
  /** 퀴즈 저장/편집 가능 여부 */
  canEditQuiz: boolean;
  publishers: SelectionSchoolInfo['publishers'];
  userCountryCode: SupportedCountryCode;
  /**
   * 서버 build-info 가 내린 "노출 중인 문제 은행의 카테고리 접두" 목록.
   * 진입점 노출은 이 목록 포함 여부로만 판정한다(`isQuizBankSupported`).
   */
  quizBankExposedCategoryPrefixes: string[];
};
